import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/41.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Długi rynek"     
        question="Dokąd idziesz dalej?" 
            audio={audio}
        answers={{
            ans1: "Na mały rynek.",
            ans2: "Na duży rynek.",
            ans3: "Do karczmy pani Jasińskiej."    
        }}
        links={{
            link1: PAGES.p79,
            link2: PAGES.p80,
            link3: PAGES.p87
        }}
        content={
            <div>
                <p>
                To już czwarty giez, zdaje się, że już blisko do tego słynnego końskiego targu. Ale koni! Tu i ówdzie ktoś próbuje też sprzedać krowę lub świnię. 
                </p>
                <ul>
                    <li>
                    – Sprzedałem! – słychać głos spomiędzy wozów. – Sprzedałem kobyłę! Po obiedzie kolejka dla wszystkich u Jasińskiej!   
                    </li>
                </ul>
                <p>
                U Jasińskiej? Emila i starego Tornaua czeka niespodzianka. A może i ty zdążysz się załapać?
                </p>
            </div>
        }
        />
        
            );
}